"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HilSignalAttributes = exports.SIGNAL_ATTRIBUTE_KEYS = void 0;
const z = __importStar(require("zod"));
const merge_values_js_1 = require("../utils/merge-values.js");
exports.SIGNAL_ATTRIBUTE_KEYS = [
    'power',
    'ground',
    'analog',
    'digital',
    'exposedPad',
    'noConnect',
    'activeLow',
];
const hilSignalAttributesSchema = z.object({
    power: z.boolean().default(false),
    ground: z.boolean().default(false),
    analog: z.boolean().default(false),
    digital: z.boolean().default(false),
    exposedPad: z.boolean().default(false),
    noConnect: z.boolean().default(false),
    activeLow: z.boolean().default(false),
});
const hilSignalAttributesDtoSchema = z.object({
    power: z.boolean().optional(),
    ground: z.boolean().optional(),
    analog: z.boolean().optional(),
    digital: z.boolean().optional(),
    exposedPad: z.boolean().optional(),
    noConnect: z.boolean().optional(),
    activeLow: z.boolean().optional(),
});
exports.HilSignalAttributes = {
    create: (input) => {
        return hilSignalAttributesSchema.parse(input);
    },
    merge: (existing, incoming) => ({
        power: (0, merge_values_js_1.mergeValues)(existing.power, incoming.power),
        ground: (0, merge_values_js_1.mergeValues)(existing.ground, incoming.ground),
        analog: (0, merge_values_js_1.mergeValues)(existing.analog, incoming.analog),
        digital: (0, merge_values_js_1.mergeValues)(existing.digital, incoming.digital),
        exposedPad: (0, merge_values_js_1.mergeValues)(existing.exposedPad, incoming.exposedPad),
        noConnect: (0, merge_values_js_1.mergeValues)(existing.noConnect, incoming.noConnect),
        activeLow: (0, merge_values_js_1.mergeValues)(existing.activeLow, incoming.activeLow),
    }),
    fromSelection: (selectedKeys) => {
        return exports.HilSignalAttributes.create(Object.fromEntries(exports.SIGNAL_ATTRIBUTE_KEYS.map((key) => [key, selectedKeys.includes(key)])));
    },
    toString: (attributes) => {
        return Object.entries(attributes)
            .filter(([, value]) => value === true)
            .map(([key]) => key)
            .join(';');
    },
    fromString: (attributeString) => {
        return exports.HilSignalAttributes.create(Object.fromEntries(attributeString.split(';').map((key) => [key, true])));
    },
    schema: hilSignalAttributesSchema,
    dtoSchema: hilSignalAttributesDtoSchema,
};
//# sourceMappingURL=hil-signal-attributes.js.map